// extracted by mini-css-extract-plugin
module.exports = {"beta-tag":"beta-tag___b341D"};